export default "__VITE_ASSET__89dde7bc__"